// extracted by mini-css-extract-plugin
export default {"ctn":"Counter_ctn__V0bl6","wrapper":"Counter_wrapper__V5Omn","count":"Counter_count__mMa1x","title":"Counter_title__OC1Od"};